import { Component, type OnInit } from '@angular/core';
import { ViewMode } from './enums/view-mode';

@Component({
    selector: 'big-chat-core-toggle-button',
    template: '',
    standalone: false,
})
export class ChatCoreToggleButtonComponent implements OnInit {
    public viewModeEnum: typeof ViewMode = ViewMode;

    public visible = false;
    public viewMode: ViewMode = ViewMode.chooseChat;
    public activeViewMode!: ViewMode;

    public ngOnInit(): void {
        if (!this.activeViewMode) {
            this.activeViewMode = this.viewMode;
        }
    }
}
